enum CompetitionType {
    jednotlivci = 'Jednotlivci',
    spolecky = 'Společné skladby',
    esg = 'ESG',
}

enum ProClenyButton {
    aktualniInfo = 'Aktuální informace',
    organizaceSkolnihoRoku = 'Organizace školního roku',
    rozpisTreninku = 'Rozpis tréninků',
    clenskePrispevky = 'Členské příspěvky',
}

enum TrenerskaTrida {
    trida1 = 'I. třída',
    trida2 = 'II. třída',
    trida3 = 'III. třída',
    trida4 = 'IV. třída',
    instruktor = 'Instruktor',
    baletniPedagog = 'Baletní pedagog',
    brevet = 'BREVET'
}

export {CompetitionType, ProClenyButton, TrenerskaTrida}

